var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('star-rating',{attrs:{"increment":0.5,"read-only":true,"star-size":10,"show-rating":false,"inactive-color":"white","active-color":"#DA3D3C","border-width":1,"border-color":"#DA3D3C","rating":_vm.ratingStar}})}
var staticRenderFns = []

export { render, staticRenderFns }